import { Upload, Progress, message, notification } from "antd";
import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { getDocuments } from "../../redux/Documents/Get/GetDocumentsAction";
import { uploadDocuments } from "../../redux/Documents/Upload/UploadDocumentsAction";
import { clearLogoutData } from "../../redux/logout/action";
import { Documents_Master_Service_URL } from "../../redux/Url";
import UiButton from "../Common/UiButton/UiButton";
import useSession from "../CustomLogout/useSession";

const DocumentUpoadInput = ({
  beforeUpload,
  onRemove,
  action,
  showUploadList,
  onChange,
  name,
  item,
  team,
  defaultFileList,
  disabled,
  optionSelected,
  partnerFirmId,
  getRcuDocuments,
  setDisabled,
  extraText,
  key,
  ...props
}) => {
  const handleSessionExpired = useSession();
  const [progress, setProgress] = useState(0);
  const [uploadText, setUploadText] = useState("Upload");

  const MAX_FILE_SIZE =
    item.partnerDocumentTypeId === 16 ? 30 * 1024 * 1024 : 10 * 1024 * 1024; // 30 MB if id is 16, otherwise 10 MB

  const changeUploadTxt = () => {
    setUploadText("Change");
  };

  const beforeUploadS = (file) => {
    const filesFormats = ["image/png", "image/jpeg", "application/pdf"];

    const isRightFormat = filesFormats.includes(file.type);

    if (!isRightFormat) {
      message.error("You can only upload pdf, jpg and jpeg files");
      return isRightFormat;
    }
    const isLt2M = file.size < MAX_FILE_SIZE;

    if (!isLt2M) {
      message.error(
        `The selected file exceeds the allowed limit of ${
          MAX_FILE_SIZE / (1024 * 1024)
        }MB. Please choose a smaller file`
      );
      return isLt2M;
    }
  };

  const uploadImage = async (options) => {
    const { onSuccess, onError, file, onProgress } = options;

    //  convert file to base64 and upload it
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async () => {
      const base64 = reader.result;
      let docExt;
      if (file.type === "image/jpeg") {
        docExt = "jpg";
      } else if (file.type === "image/png") {
        docExt = "png";
      } else if (file.type === "application/pdf") {
        docExt = "pdf";
      }
      const data = {
        partnerDocumentTypeId: item?.partnerDocumentTypeId,
        optionSelected: optionSelected
          ? optionSelected?.partnerDocumentTypeId
          : null,
        fileName: file.name,
        section: item?.section,
        partnerTeamId: team?.partnerTeamId ?? null,
        partnerBranchId: item.partnerBranchId ?? null,

        documentDetails: {
          base64: `${base64}`,
          docTypeId: `${
            optionSelected ? optionSelected?.value : item.dmsDocTypeId
          }`,
          docExt: `${docExt}`,
        },
      };
      try {
        setDisabled(true);
        const res = await axios({
          method: "post",
          url: `${Documents_Master_Service_URL}/uploadDocument`,
          headers: { authorization: "Bearer " + props.accessToken },
          params: {
            partnerFirmId: props.firmId,
          },
          data: data,
          onUploadProgress: (event) => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            setProgress(percent);
            if (percent === 100) {
              setTimeout(() => setProgress(0), 1000);
            }
            onProgress({ percent: (event.loaded / event.total) * 100 });
          },
        });
        if (res.status === 200) {
          onSuccess("Ok");
          setUploadText("Change");
          getDocuments();
          message.success(`${file.name} file uploaded successfully`);
          setDisabled(false);
        } else {
          message.error(res.error.message);
          setDisabled(false);
        }
      } catch (err) {
        const res = err?.response;
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;
          setDisabled(false);

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }

        onError({ err });
        // message.error(err.response.data.error.message);
      }
    };
  };

  const getBase64 = (file, cb) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {};
  };

  const uploadImage2 = async (options) => {
    const { onSuccess, onError, file, onProgress } = options;
    if (file.size > MAX_FILE_SIZE) {
      message.error(
        `The selected file exceeds the allowed limit of ${
          MAX_FILE_SIZE / (1024 * 1024)
        }MB. Please choose a smaller file`,
        4
      );
      return false; // Prevent the file from being uploaded
    }
    getBase64(file, async (result) => {
      let docExt;
      if (file.type === "image/jpeg") {
        docExt = "jpg";
      } else if (file.type === "image/png") {
        docExt = "png";
      } else if (file.type === "application/pdf") {
        docExt = "pdf";
      }
      const data = {
        partnerDocumentTypeId: item?.partnerDocumentTypeId,
        optionSelected: optionSelected
          ? optionSelected?.partnerDocumentTypeId
          : null,
        fileName: file.name,
        section: item?.section,
        partnerTeamId: team?.partnerTeamId ?? null,
        partnerBranchId: item.partnerBranchId ?? null,
        documentDetails: {
          base64: `${result?.split(",")[1]}`,
          docTypeId: `${
            optionSelected ? optionSelected?.value : item.dmsDocTypeId
          }`,
          docExt: `${docExt}`,
        },
      };
      // how to remove

      try {
        setDisabled(true);
        const res = await axios({
          method: "post",
          url: `${Documents_Master_Service_URL}/uploadDocument`,
          headers: { authorization: "Bearer " + props.accessToken },
          params: {
            partnerFirmId: partnerFirmId || props.firmId,
          },
          data: data,
          onUploadProgress: (event) => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            setProgress(percent);
            if (percent === 100) {
              setTimeout(() => setProgress(0), 1000);
            }
            onProgress({ percent: (event.loaded / event.total) * 100 });
          },
        });
        if (res.status === 200) {
          setDisabled(false);
          onSuccess("Ok");
          setUploadText("Change");
          getDocuments();
          message.success(`${file.name} file uploaded successfully`);
        }
      } catch (err) {
        const res = err?.response;
        if (res?.data?.error || res.message) {
          setDisabled(false);
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
            return;
          } else {
            setDisabled(false);
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
        onError({ err });
        // message.error(err.response.data.error.message);
      }
    });
  };

  const getDocuments = () => {
    if (getRcuDocuments) {
      getRcuDocuments();
    } else {
      props.getDocuments({
        partnerFirmId: props.firmId,
        accessToken: props.accessToken,
      });
    }
  };

  useEffect(() => {
    if (defaultFileList?.length > 0) {
      setUploadText("Change");
    }
  }, [defaultFileList]);

  return (
    <div class="container">
      <Upload
        listType="text"
        className="selected-optdoc"
        showUploadList={showUploadList}
        defaultFileList={defaultFileList}
        key={key}
        accept=".pdf,.png,.jpg"
        beforeUpload={beforeUploadS}
        onRemove={onRemove}
        customRequest={uploadImage2}
        disabled={disabled}
        onChange={(e) => {
          // changeUploadTxt();
          onChange(e);
        }}
        maxCount={1}
      >
        <UiButton
          type={disabled ? "submit" : "button"}
          title={`${uploadText}`}
          disabled={disabled}
        />
      </Upload>
      {/* {progress > 0 ? <Progress percent={progress} /> : null} */}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    documentsMaster: state.documentsMaster,
    firmId:
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId ||
      sessionStorage.getItem("cetFirmId"),
    accessToken: state?.auth?.idToken,
    companyDocumentsList: state.documentsMaster?.companyDocumentsList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    uploadDocuments: (user) => dispatch(uploadDocuments(user)),
    getDocuments: (user) => dispatch(getDocuments(user)),
    clearLogoutData: (user) => dispatch(clearLogoutData(user)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentUpoadInput);
